<template>
  <div class="table-container">
    <TableItem
      class="comment-card"
      :value="item"
      v-for="(item, index) in list"
      :key="index"
      v-model="list[index]"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TableItem from './table-item.vue';

@Component({
  components: {
    TableItem
  }
})
export default class Table extends Vue {
  @Prop({ type: Array, default: () => [] }) value;

  list = [];

  @Watch('value', { immediate: true })
  onValueChanage(val = []) {
    this.list = [...val];
  }
}

</script>

<style lang="scss" scoped>
  .comment-card {
    margin: 20px 0;
  }

  .table-container {
    height: 100%;
    overflow: auto;
  }
</style>

